import { Controller } from './controls'
import { ParticleEngine } from './particles'
import { SoundEngine } from './sound/sound-engine'
import { Profiler } from './profiler'
import '../styles/index.scss'
import { SensorService } from './sensors/sensor-service'
import { logToDebugConsole } from './debug/debug-log'
import { Renderer } from './renderers/renderer'
import { GpuRenderer } from './renderers/gpu-renderer'
import {CanvasRenderer} from "./renderers/canvas-renderer";

const consoleLogOrg = console.log

console.log = (msg) => {
  logToDebugConsole(msg)
  consoleLogOrg(msg)
}

let renderer: Renderer
let particleEngine: ParticleEngine
let profiler: Profiler
let sensorService: SensorService
document.addEventListener('DOMContentLoaded', () => {
  renderer = new GpuRenderer()
  const soundEngine = new SoundEngine()
  sensorService = new SensorService()
  particleEngine = new ParticleEngine(renderer, soundEngine, sensorService)
  profiler = new Profiler(particleEngine)
  new Controller(particleEngine, soundEngine, profiler, renderer, sensorService)
  window.requestAnimationFrame(startLoop)
})


let oldTimeStamp: number | undefined

function startLoop(timestamp: number): void {
  if (oldTimeStamp) {
    const deltaTimeMs = (timestamp - oldTimeStamp)
    profiler.updateFpsCounter(deltaTimeMs)
    const particleInfo = particleEngine.updateParticles(deltaTimeMs, timestamp)
    renderer.draw(particleInfo, particleEngine.grid, timestamp)
  }
  oldTimeStamp = timestamp

  window.requestAnimationFrame(startLoop)
}







